import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { rateLimitMessage } from '../../../_helpers/rate-limit';
import { Router } from '@angular/router';
import { NbAuthService, NbRequestPasswordComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { AuthService } from '../../../_services/auth.service';
import { LoggerService } from '../../../_services/logger.service';
import { NotifierService } from '../../../_services/notifier.service';
//import { NbAlertModule } from '../../pages.module';

@Component({
    selector: 'reset-psw',
    templateUrl: './reset-psw.component.html',
    styleUrls: ['./reset-psw.component.scss'],
    standalone: false
})
export class ResetPswComponent extends NbRequestPasswordComponent {

  constructor(
    // Servizi richiesti da NbResetPasswordComponent
    protected authService: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected override options = {},
    protected override cd: ChangeDetectorRef,
    protected override router: Router,
    // Servizi custom
    private auth: AuthService,
    private loggerService: LoggerService,
    private alertService: NotifierService,
  ) {
    super(
      authService,
      options,
      cd,
      router,
    );
  }

  // requestPass == reset pass, Nebular usa dei nomi del cazzo
  override requestPass() {
    // Double click / Enter must not send the reset twice (5 attempts / 15 min).
    if (this.submitted) return;
    console.info('[ResetPassword] requestPass called', {
      email: this.user.email,
    });

    this.errors = this.messages = [];
    this.submitted = true;

    console.info('[ResetPassword] calling auth.resetPassword');

    this.auth.resetPassword(this.user.email).toPromise()
    .then(res => {
        console.info('[ResetPassword] auth.resetPassword response', res);

        if (res?.errors && res?.errors.length > 0)
          throw new Error(rateLimitMessage(res.errors[0]) || "Errore durante il ripristino della password");
        this.submitted = false;
        this.alertService.success("Richiesta inviata", "Controlla le tue mail per confermare la richiesta");
        // Redirect alla pagina di login
        setTimeout(() => {
          return this.router.navigateByUrl("/auth/login");
        }, this.redirectDelay);
    })
    .catch(err => {
      console.error('[ResetPassword] auth.resetPassword error', err);

      this.submitted = false;
      this.alertService.error("Errore", rateLimitMessage(err)
        || "E' avvenuto un errore durante il processo di ripristino della password");
      this.loggerService.error(err.message);
    });

  }

}
